import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/major-finder/page.tsx");
